import { createSlice } from "@reduxjs/toolkit";

const HOMEPAGE = "pages/fetchHomepageData";

const uiSlice = createSlice({
  name: "ui",
  initialState: {
    theme: null,
    toggleMenu: false,
    noty: null,
    countNoty: null,
    ads: null,
    homeLoading: true,
  },
  reducers: {
    setChangeTheme(state, action) {
      state.theme = action.payload;
    },
    toggleMenu(state, action) {
      state.toggleMenu = action.payload;
    },
    setNewNoty(state, action) {
      state.noty = action.payload;
    },
    setNewCountNoty(state, action) {
      state.countNoty = action.payload;
    },
    setNewAds(state, action) {
      state.ads = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(HOMEPAGE + "/pending", (state) => {
        state.homeLoading = true;
      })
      .addCase(HOMEPAGE + "/fulfilled", (state, action) => {
        state.homeLoading = false;
        const payload = action.payload || {};
        state.ads = payload.Ads ?? payload?.data?.Ads ?? null;
      })
      .addCase(HOMEPAGE + "/rejected", (state) => {
        state.homeLoading = false;
      });
  },
});

export const {
  setChangeTheme,
  toggleMenu,
  setNewNoty,
  setNewCountNoty,
  setNewAds,
} = uiSlice.actions;

export default uiSlice.reducer;
